export enum ButtonIcons {
  plusIcon = 'plus-icon',
  plusIconDark = 'plus-icon-dark',
  plusIconBlack = 'plus-icon-black',
  closeIcon = 'close-icon',
  closeIconDark = 'dark-close-icon',
  searchIcon = 'search-icon',
  searchIconWhite = 'search-icon-white',
  filterIcon = 'filter-setting-icon',
  pencilIcon = 'pencil-icon',
  addIcon = 'add-icon',
  bankIcon = 'post-bank-icon',
  addPerson = 'add-person',
  addPersonTick = 'add-person-tick',
  addPersonPlus = 'add-person-plus',
  addPersonPlusDark = 'add-person-plus-dark',
  searchContact = 'search-person',
  createPerson = 'create-person',
  switchBank = 'switch-bank-icon',
  saveIcon = 'save-icon',
  setting = 'setting-icon',
  entity = 'entity',
  delete = 'delete-icon',
  deleteRed = 'delete-icon-red',
  editPencil = 'edit-pencil',
  editDetailsIcon = 'edit-details-icon',
  Activity = 'activity',
  userRelationship = 'user-relationship',
  arrowLeft = 'arrow-left',
  arrowUp = 'arrow-up',
  arrowDown = 'arrow-down',
  arrowRight = 'arrow-right',
  SaveFloppy = 'saveFloppy',
  listChecksLine = 'square-check',
  circleClose = 'circle-close',
  refundIcon = 'refund-icon',
  playIcon = 'play-icon',
  PlusRoundIcon = 'plus-round-icon',
  editButton = 'edit-button',
  timerIcon = 'timer-icon',
  magnifyIcon = 'magnify-icon',
  arrowRightTail = 'arrow-right-tail',
  arrowUndo = 'arrow-undo',
  userSearch = 'user-search',
}
